import { useLazyGetUsersQuery } from "features/api/permissionsApi.ts";
import PeopleSettingsTable from "components/Preferences/PeopleSettings/PeopleSettingsTable.tsx";
import { useContext, useEffect, useState } from "react";
import { models } from "types/api/viewModels.ts";
import { PeopleContainer, PeopleSettingLandingPageHeader } from "pages/Preferences/People/PeopleSettingsPage.styles.ts";
import { AllPeopleHeaderText } from "components/Preferences/text.ts";
import { useGetUserDetailsQuery } from "features/api/userApi.ts";
import ConfigurationsContext from "context/configurations/ConfigurationsContext.ts";
import APIErrorCustomBanner from "components/Common/APIErrorCustomBanner/APIErrorCustomBanner.tsx";
import { UserPermission } from "types/declarations/enums.ts";

const PeopleSettingsPage = () => {
	const [trigger] = useLazyGetUsersQuery();
	const { data: userDetails } = useGetUserDetailsQuery();
	const isAdmin = userDetails?.permissions?.find((x) => x === UserPermission.ADMIN) ?? false;
	const [availableUsers, setAvailableUsers] = useState<models["PersonPermissionsViewModel"][] | null | undefined>();
	const [loading, setLoading] = useState(true);
	const { configurationsData } = useContext(ConfigurationsContext);
	const isUserPreferenceEnabled = configurationsData?.featureFlags?.userPreferenceEnabled ?? false;

	useEffect(() => {
		trigger()
			.unwrap()
			.then((res) => setAvailableUsers(res))
			.catch(() => {
				// Error is handled by setting loading to false
				// Component will render with undefined availableUsers
			})
			.finally(() => setLoading(false));
	}, [trigger]);

	if (!isAdmin || !isUserPreferenceEnabled) {
		return (
			<div>
				<APIErrorCustomBanner statusCode={403} />
			</div>
		);
	}

	return (
		<>
			<PeopleSettingLandingPageHeader>
				<h1>{AllPeopleHeaderText}</h1>
			</PeopleSettingLandingPageHeader>
			<PeopleContainer>
				<PeopleSettingsTable
					isLoading={loading}
					people={availableUsers}
				/>
			</PeopleContainer>
		</>
	);
};

export default PeopleSettingsPage;
